// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1gZDZ","subheader":"ReorderModal_subheader__3uLy_","listWrap":"ReorderModal_listWrap__ABIVb"};